import axios from "axios";
import { apiActiveURL, appId, appKey } from "../../ApiBaseURL";

export const GetHotel = (data) => {
  var config = {
    url: `${apiActiveURL}/looks/${data.key}`,
    method: "GET",
    headers: {
      AppKey: appKey,
      AppId: appId,
    },
  };

  return (dispatch) => {
    axios(config)
      .then((res) => {
        if (res.data.status) {
          GetHotelSuccess(dispatch, res);
        } else {
          GetHotelFail(dispatch);
        }
      })
      .catch((e) => {
        GetHotelFail(dispatch);
      });
  };
};
export const ResetGetHotel = () => {
  return (dispatch) => {
    dispatch({ type: "GET_HOTEL_SUCCESS", payload: null });
  };
};

const GetHotelSuccess = (dispatch, res) => {
  dispatch({ type: "GET_HOTEL_SUCCESS", payload: res });
};

const GetHotelFail = (dispatch) => {
  dispatch({ type: "GET_HOTEL_FAIL", payload: "Something Went Wrong" });
};

export const ResetGetHotelError = () => {
  return (dispatch) => {
    dispatch({ type: "GET_HOTEL_FAIL", payload: null });
  };
};
